import { useAuth } from '@modules/auth/use-auth.hook'
import { Roles } from '@shared/types'

export function useACL() {
  const { authenticatedUser, authStatus } = useAuth()

  return {
    is(roles: Roles[]) {
      if (authStatus === 'unknown') {
        return true
      }

      return Boolean(
        authenticatedUser?.userRoles
          .map(({ roleName }) => roleName)
          .some((userRoleName) => roles.includes(userRoleName))
      )
    },
  }
}
